import { Images } from '@/assets/images';
import { DocTypeEnum } from '@/constant';
import { dayjs, formatDate } from '@/utils';

import { isNotNilOrEmpty } from 'ramda-adjunct';
import * as Yup from 'yup';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	organizationName: '',
	employerName: '',
	employerSignature: '',
	agriculturalBusinessRegistrationNumber: '',
	writeDate: '',
	// Checklist items (19 items - Yes/No for each)
	checklist1: 'O',
	checklist2: 'O',
	checklist3: 'O',
	checklist4: 'O',
	checklist5: 'O',
	checklist6: 'O',
	checklist7: 'O',
	checklist8: 'O',
	checklist9: 'O',
	checklist10: 'O',
	checklist11: 'O',
	checklist12: 'O',
	checklist13: 'O',
	checklist14: 'O',
	checklist15: 'O',
	checklist16: 'O',
	checklist17: 'O',
	checklist18: 'O',
	checklist19: 'O',
};

type IValues = typeof initializeValue;

const YES_NO_OPTIONS = ['O', 'X']; // O for Yes, X for No

export const AGRICULTURAL_WORKPLACE_SAFETY_CHECKLIST_FOR_EMPLOYERS_CONFIG: FormConfig<
	IValues,
	DocTypeEnum.FRF_12
> = {
	initializeValue,
	title: '농업 안전관리 체크리스트[고용주용]',
	mapPropToValues({ franchiseData, detailData, unitData }) {
		return {
			organizationName: detailData?.unitInfo?.name || unitData?.name || '',
			employerName: franchiseData?.employerName || '',
			agriculturalBusinessRegistrationNumber:
				franchiseData?.businessRegistNo ||
				franchiseData?.corporateRegistNo ||
				'',
			writeDate: formatDate(dayjs()),
		};
	},
	pages: [
		{
			background: {
				src: Images.formAgriculturalWorkplaceSafetyChecklistForEmployers,
				className: 'template',
				dataSource: Images.formAgriculturalWorkplaceSafetyChecklistForEmployers,
			},
			textAreas: [
				(values, index) => ({
					name: 'organizationName',
					maxHeight: 20,
					maxLength: 20,
					containerClassName: 'absolute top-[150px] left-[171px] w-[244px]',
					className: 'text-[13px]',
				}),
				(values, index) => ({
					name: 'employerName',
					maxHeight: 26,
					maxLength: 38,
					containerClassName: 'absolute top-[170px] left-[171px] w-[244px]',
					className: 'text-[13px] leading-[12px]',
				}),
				(values, index) => ({
					name: 'agriculturalBusinessRegistrationNumber',
					maxHeight: 26,
					maxLength: 20,
					containerClassName: 'absolute top-[193px] left-[253px] w-[162px]',
					className: 'text-[13px] leading-[12px]',
				}),
			],
			checkboxes: [
				// Checklist item 1
				{
					name: 'checklist1',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[271px] right-[153px] w-6 h-6', // Yes (O)
						'absolute top-[271px] right-[97px] w-6 h-6', // No (X)
					],
					iconType: 'circle',
				},
				// Checklist item 2
				{
					name: 'checklist2',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[310px] right-[153px] w-6 h-6',
						'absolute top-[310px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 3
				{
					name: 'checklist3',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[346px] right-[153px] w-6 h-6',
						'absolute top-[346px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 4
				{
					name: 'checklist4',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[400px] right-[153px] w-6 h-6',
						'absolute top-[400px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 5
				{
					name: 'checklist5',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[447px] right-[153px] w-6 h-6',
						'absolute top-[447px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 6
				{
					name: 'checklist6',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[484px] right-[153px] w-6 h-6',
						'absolute top-[484px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 7
				{
					name: 'checklist7',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[512px] right-[153px] w-6 h-6',
						'absolute top-[512px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 8
				{
					name: 'checklist8',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[539px] right-[153px] w-6 h-6',
						'absolute top-[539px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 9
				{
					name: 'checklist9',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[575px] right-[153px] w-6 h-6',
						'absolute top-[575px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 10
				{
					name: 'checklist10',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[612px] right-[153px] w-6 h-6',
						'absolute top-[612px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 11
				{
					name: 'checklist11',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[649px] right-[153px] w-6 h-6',
						'absolute top-[649px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 12
				{
					name: 'checklist12',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[693px] right-[153px] w-6 h-6',
						'absolute top-[693px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 13
				{
					name: 'checklist13',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[740px] right-[153px] w-6 h-6',
						'absolute top-[740px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 14
				{
					name: 'checklist14',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[777px] right-[153px] w-6 h-6',
						'absolute top-[777px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 15
				{
					name: 'checklist15',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[808px] right-[153px] w-6 h-6',
						'absolute top-[808px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 16
				{
					name: 'checklist16',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[837px] right-[153px] w-6 h-6',
						'absolute top-[837px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 17
				{
					name: 'checklist17',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[893px] right-[153px] w-6 h-6',
						'absolute top-[893px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 18
				{
					name: 'checklist18',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[952px] right-[153px] w-6 h-6',
						'absolute top-[952px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
				// Checklist item 19
				{
					name: 'checklist19',
					options: YES_NO_OPTIONS,
					classNames: [
						'absolute top-[989px] right-[153px] w-6 h-6',
						'absolute top-[989px] right-[97px] w-6 h-6',
					],
					iconType: 'circle',
				},
			],
			signatures: [
				{
					name: 'employerSignature',
					className: 'absolute top-[155px] left-[468px] w-[248px] h-[50px]',
				},
			],
			datePickers: [
				{
					name: 'writeDate',
					segmentedInputs: true,
					format: '                  YYYY              MM            DD',
					containerClassName: 'absolute top-[210px] left-[484px]',
					style: { fontSize: '14px' },
				},
			],
			highlightBoxes: [
				{
					name: 'organizationName',
					className: 'absolute top-[151px] left-[171px] w-[244px] !h-[19px]',
				},
				{
					name: 'employerName',
					className: 'absolute top-[173px] left-[171px] w-[244px] !h-[19px]',
				},
				{
					name: 'agriculturalBusinessRegistrationNumber',
					className: 'absolute top-[195px] left-[253px] w-[162px] !h-[19px]',
				},
				{
					name: 'employerSignature',
					className: 'absolute top-[155px] left-[468px] w-[248px] !h-[50px]',
				},
				{
					name: 'writeDate',
					className: 'absolute top-[210px] left-[484px] w-[233px] !h-[20px]',
				},
				{
					names: [
						'checklist1',
						'checklist2',
						'checklist3',
						'checklist4',
						'checklist5',
						'checklist6',
						'checklist7',
						'checklist8',
						'checklist9',
						'checklist10',
						'checklist11',
						'checklist12',
						'checklist13',
						'checklist14',
						'checklist15',
						'checklist16',
						'checklist17',
						'checklist18',
						'checklist19',
					],
					className: 'absolute top-[238px] left-[601px] w-[113px] !h-[16px]',
				},
			],
		},
	],
	validationSchema: Yup.object()
		.shape({
			organizationName: Yup.string().required(),
			employerName: Yup.string().required(),
			employerSignature: Yup.string().required(),
			agriculturalBusinessRegistrationNumber: Yup.string().required(),
			writeDate: Yup.string().required(),
		})
		.test(
			'at-least-one-field',
			'At least one field must have data',
			function (value) {
				const fields = [
					'checklist1',
					'checklist2',
					'checklist3',
					'checklist4',
					'checklist5',
					'checklist6',
					'checklist7',
					'checklist8',
					'checklist9',
					'checklist10',
					'checklist11',
					'checklist12',
					'checklist13',
					'checklist14',
					'checklist15',
					'checklist16',
					'checklist17',
					'checklist18',
					'checklist19',
				];

				return fields.some((field) =>
					// @ts-expect-error: ignore here
					isNotNilOrEmpty(value[field])
				);
			}
		),
};
